import Grid from '@mui/material/Grid2';
import LabeledTextField from './labeledTextField';

export default function PhoneInputField({ model, handleValueChanged, size }) {
    if (!size) {
        size = 12;
    }
    return (
        <Grid size={size}>
            <Grid container spacing={0.5}>
                <Grid size={3}>
                    <LabeledTextField
                        label='Area Code'
                        value={model?.contactAreaCode || ''}
                        onChange={(e) => handleValueChanged('contactAreaCode', e.target.value)}
                        maxLength={3}
                        fullWidth
                        error={!model?.contactAreaCode}
                        helperText={!model?.contactAreaCode ? 'Area Code is required' : null}
                    />
                </Grid>
                <Grid size={5}>
                    <LabeledTextField
                        label='Phone Number'
                        value={model?.contactPhone || ''}
                        onChange={(e) => handleValueChanged('contactPhone', e.target.value)}
                        maxLength={7}
                        fullWidth
                        error={!model?.contactPhone}
                        helperText={!model?.contactPhone ? 'Phone Number is required' : null}
                    />
                </Grid>
                <Grid size={4}>
                    <LabeledTextField
                        label='Extension'
                        value={model?.contactExtension || ''}
                        onChange={(e) => handleValueChanged('contactExtension', e.target.value)}
                        maxLength={4}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}